import { render, staticRenderFns } from "./PlayoffModal.vue?vue&type=template&id=06967b8c&scoped=true"
import script from "./PlayoffModal.vue?vue&type=script&lang=js"
export * from "./PlayoffModal.vue?vue&type=script&lang=js"
import style0 from "./PlayoffModal.vue?vue&type=style&index=0&id=06967b8c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "06967b8c",
  null
  
)

export default component.exports